import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LngLatFieldsComponent } from './lng-lat-fields.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { LngLatPickerModule } from '@components/lng-lat-picker/lng-lat-picker.module'
import { NumberInputModule } from '@components/number-input/number-input.module'

@NgModule({
  declarations: [LngLatFieldsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    ContentEditableModule,
    LngLatPickerModule,
    NumberInputModule,
  ],
  exports: [LngLatFieldsComponent],
})
export class LngLatFieldsModule {}
